import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
  selector: 'mbs-step',
  imports: [NgClass],
  templateUrl: './step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepComponent {
  public readonly bodyClasses = input<string>('');
  public readonly isSimple = input<boolean>(false);
  public readonly number = input<number>(1);
  public readonly readOnly = input<boolean>(false);
  public readonly status = model<'active' | 'success'>(null);

  public accessor lastStep = false;
  public accessor singleStep = false;

  activate(): void {
    this.status.set('active');
  }

  complete(): void {
    this.status.set('success');
  }

  pending(): void {
    this.status.set(null);
  }
}
